var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card-wrapper"},[_c('div',{staticClass:"step"},[_vm._v(_vm._s(_vm.topText))]),_c('div',{staticClass:"card"},[_vm._t("content")],2),_c('div',{staticClass:"end-suffix"},[_vm._t("end-suffix")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }